import { compose, filter, map } from 'ramda';
import { createSelector } from 'reselect';

import user from 'features/views/user';

import { byAgencyId, byChannelId, byManager, byRegionId, restrictBy, toUserName } from '../utils';
import { selectors } from './reducer';

export const getAllSellers = selectors.getData;

export const getSellerByLogin = (login) => (state) => {
	return getAllSellers(state).find((seller) => seller.login === login);
};

export const getSellers = createSelector(
	(_, formData) => formData?.channel,
	(_, formData) => formData?.region,
	(_, formData) => formData?.agency,
	(_, formData) => formData?.manager,
	getAllSellers,
	user.selectors.getAllowedSellers,
	(channelId, regionId, agencyId, manager, sellers, allowedSellers) =>
		compose(
			map(toUserName),
			restrictBy(allowedSellers),
			filter(byManager(manager)),
			filter(byAgencyId(agencyId)),
			filter(byRegionId(regionId)),
			filter(byChannelId(channelId)),
		)(sellers),
);

export const getSellersForSidebar = createSelector(
	(state, formData) => formData?.channel,
	(state, formData) => formData?.region,
	(state, formData) => formData?.agency,
	(state, formData) => formData?.manager,
	getAllSellers,
	user.selectors.getAllowedSellers,
	(state, formData, customAllowedSellers) => customAllowedSellers,
	(channelId, regionId, agencyId, manager, sellers, baseAllowedSellers, customAllowedSellers) =>
		compose(
			map(toUserName),
			restrictBy(customAllowedSellers),
			restrictBy(baseAllowedSellers),
			filter(byManager(manager)),
			filter(byAgencyId(agencyId)),
			filter(byRegionId(regionId)),
			filter(byChannelId(channelId)),
		)(sellers),
);
